import type { ProductInterface } from "@/features/products/type";

export function formatPrice(value: number, isCentime: boolean = true): string {
  // Si la valeur est en centimes, la convertir en euros
  const euros = isCentime ? value / 100 : value;
  return euros.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\./g, ',');
}

export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getUnit = (product: ProductInterface) => {
  switch (product.sales_unit) {
    case 'volume':
      return (product.unit_of_sale > 1 ? product.unit_of_sale : '') + 'm³'
    case 'unit':
      return 'unité'
    default:
      return 'unité'
  }
}

// Vérifie si un produit a une écotaxe
export const hasEcotax = (product: ProductInterface): boolean => {
  return !!(product.unit_ecotax_ttc && product.density && product.unit_ecotax_ttc > 0);
}

// Formate les prix pour un produit avec gestion HT/TTC par m3
export const formatProductPrice = (product: ProductInterface, quantity: number = 1): {
  ttcPrice: string,
  htPrice: string,
  ecotaxAmount: string,
} => {

  const htPriceTotal = product.unit_price_ht * quantity;
  const ttcPriceTotal = product.unit_price_ttc * quantity;
  const ecotaxTotal = product.unit_ecotax_ttc * quantity;

  return {
    htPrice: formatPrice(htPriceTotal),
    ttcPrice: formatPrice(ttcPriceTotal),
    ecotaxAmount: formatPrice(ecotaxTotal),
  };
}

// Formate les prix pour un produit avec gestion HT/TTC par Tonne
export const formatProductPriceByTonne = (product: ProductInterface, quantity: number = 1): {
  ttcPrice: string,
  htPrice: string,
} => {

  const htPriceTotal = product.price_per_tonne_ht * quantity;
  const ttcPriceTotal = product.price_per_tonne_ttc * quantity;

  return {
    htPrice: formatPrice(htPriceTotal),
    ttcPrice: formatPrice(ttcPriceTotal),
  };
}

export function getUserTypeLabel(type: string): string {
  switch (type) {
    case 'user_individual':
      return 'Utilisateur Particulier';
    case 'user_professional':
      return 'Utilisateur Professionnel (SEPA)';
    case 'user_professional_card':
      return 'Utilisateur Professionnel (Carte)';
    case 'storekeeper':
      return 'Magasinier';
    default:
      return type;
  }
}
